<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">历史会员购买分析
          <el-popover
            placement="right"
            width="360"
            trigger="hover"
          >
            <div>产生过购买行为即为已购会员，反之则为未购会员。</div>
            <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
          </el-popover>
        </div>
      </div>
      <div class="history_member_analysis">
        <!-- 查询条件 -->
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="会员等级：">
            <el-select style="width: 204px;" v-model="form.level" multiple placeholder="请选择" @change="levelChange">
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button class="status_btn status_btn1" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetData">重置</el-button>
            <el-button class="exportData" @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
          style="width: 100%; margin-top: 24px;"
          v-loading="loading"
        >
          <el-table-column prop="memberType" label=" " align="center">
          </el-table-column>
          <el-table-column prop="memberNum" label="人数" align="center">
          </el-table-column>
          <el-table-column prop="memberRate" label="人数占比" align="center">
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <div>暂无任何数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 生成报表 -->
    <generate
      v-if="control"
      :control="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    />
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import { exportDataOne, getTableData } from "@/api/analysis/history_member_analysis";

export default {
  components: {
    generate,
  },

  data() {
    return {
      loading: false,
      control: false,
      form: {
        // 表单查询条件
        level: [""],
      },
      tableData: [], // 表格数据
      exportParams: {}, // 导出参数
      levelList: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 1,
          label: "一星会员",
        },
        {
          value: 2,
          label: "二星会员",
        },
        {
          value: 3,
          label: "三星会员",
        },
        {
          value: 4,
          label: "四星会员",
        },
        {
          value: 5,
          label: "五星会员",
        },
      ]
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "历史会员购买分析", "数据分析", "客户分析");
    this.queryData()
  },

  methods: {
    levelChange(val) {
      if (val.length) {
        if (val[val.length - 1] == "") {
          this.form.level = [""]
        } else {
          this.form.level = val.filter(item => item != "")
        }
      }
    },

    // 查询
    queryData() {
      const level = this.form.level.join(",")
      this.exportParams = {...this.form, level}
      this.loading = true
      getTableData({...this.form, level}).then((res) => {
        this.loading = false
        if (res.code != 1) {
          return this.$message.error(res.message || res.data.message)
        }
        this.tableData = res.data || []
      })
    },

    // 重置
    resetData() {
      this.form = {
        level: [""],
      }
      this.queryData()
    },

    exportData() {
      this.control = true;
    },

    getphone(val) {
      const params = {
        ...this.exportParams,
        exportRemark: val,
      };
      exportDataOne(params).then((res) => {
        if (res.code == 1) {
          this.control = true;
        } else {
          this.$message.error(res.message || res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .history_member_analysis {
    padding: 28px;

    .status_btn {
      width: 98px;
      background-color: #fff;
      font-size: 14px;
      margin-left: 20px;
    }

    .status_btn1 {
      color: #fe4d45;
      border-color: #fe4d45;
      margin-left: 0;
    }

    .status_btn1:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }

    .status_btn2 {
      margin-left: 8px;
      color: #333;
      border-color: #d9d9d9;
    }

    .status_btn2:hover {
      color: #fe4d45;
      border-color: #fe4d45;
      background-color: #ffe5e5;
    }

    .exportData {
      float: right;
    }

    .empty {
      padding: 40px 0;
      text-align: center;
      line-height: 30px;
    }

    .toolTipSet {
      width: 600px !important;
    }

    /deep/.el-select__tags {
      position: absolute;
      line-height: normal;
      white-space: normal;
      z-index: 1;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
      overflow: hidden;
    }
  }
}
</style>
